/**
 * Shared date formatting utilities.
 *
 * All "display" formatting goes through these helpers so the app renders
 * dates consistently and the logic lives in one place.
 */

/**
 * Format a date value as a full locale date+time string.
 * Returns a dash when the input is falsy (null / undefined / empty string).
 */
export function formatDateTime(dateValue: string | Date | null | undefined): string {
  if (!dateValue) return '\u2014';
  return new Date(dateValue).toLocaleString();
}

/**
 * Format an ISO date string as YYYY-MM-DD (date-only, no time component).
 * Uses the sv-SE locale for a consistent numeric format.
 */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' });
}
